// Local Floci mode: dev server only. `DEV` is false in any build, so a leaked flag is inert.
export const IS_LOCAL_FLOCI =
  import.meta.env.DEV && import.meta.env['VITE_LOCAL_FLOCI'] === 'true';

const LOCALHOST_SUFFIX = '.localhost';

/**
 * Returns the URL to upload to. Outside local mode it is the presigned URL
 * unchanged. In local mode it is routed through Vite's /floci-proxy so the
 * browser call is same-origin, with virtual-host URLs (`<bucket>.localhost`)
 * converted to the path style the proxy route needs.
 */
export const resolveUploadUrl = (url: string): string => {
  if (!IS_LOCAL_FLOCI) {
    return url;
  }
  const { hostname, pathname, search } = new URL(url);
  const bucket = hostname.endsWith(LOCALHOST_SUFFIX)
    ? hostname.slice(0, -LOCALHOST_SUFFIX.length)
    : '';
  const path = bucket ? `/${bucket}${pathname}` : pathname;
  return `${window.location.origin}/floci-proxy${path}${search}`;
};
